import React, { useState, useEffect } from "react";
import axios from "../Axios/Axios";
import { FaTimes, FaEdit, FaTrash, FaSpinner } from "react-icons/fa"; // Loader icon
import swal from "sweetalert";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CustomerTable() {
  const [customers, setCustomers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ id: null, name: "", contite: "" });
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [loading, setLoading] = useState(false); // Loader state
  const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");

  // Get all materials
  const fetchMaterials = async () => {
    try {
      setLoading(true); // Start loader
      const res = await axios.get("/api/materials/all", {
        headers: {
          Authorization: `Bearer ${mughalsLoggedIn}`,
        },
      });
      setCustomers(res.data);
    } catch (err) {
      console.error("Error fetching materials:", err);
    } finally {
      setLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    fetchMaterials();
  }, []);

  const openAddModal = () => {
    setFormData({ id: null, name: "", contite: "" });
    setIsEditMode(false);
    setShowModal(true);
  };

  const openEditModal = (customer) => {
    setFormData({
      id: customer._id,
      name: customer.name,
      contite: customer.quantity,
    });
    setIsEditMode(true);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) {
      alert("Please fill all fields.");
      return;
    }

    try {
      setLoading(true); // show loader on submit
      if (isEditMode) {
        await axios.put(
          `/api/materials/${formData.id}`,
          {
            name: formData.name,
            quantity: Number(formData.contite),
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${mughalsLoggedIn}`,
            },
          }
        );
        swal("Updated!", "Material updated successfully!", "success");
      } else {
        await axios.post(
          "/api/materials/add",
          {
            name: formData.name,
            quantity: Number(formData.contite),
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${mughalsLoggedIn}`,
            },
          }
        );
        swal("Added!", "Material added successfully!", "success");
      }
      fetchMaterials();
      closeModal();
    } catch (err) {
      console.error("Error saving material:", err);
      swal("Error!", "Something went wrong.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "This material will be deleted!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true); // loader start on delete
          await axios.delete(`/api/materials/${id}`, {
            headers: {
              Authorization: `Bearer ${mughalsLoggedIn}`,
            },
          });
          swal("Deleted!", "Material has been deleted.", "success");
          fetchMaterials();
        } catch (err) {
          console.error("Error deleting material:", err);
          swal("Error!", "Failed to delete.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const filteredCustomers = customers.filter(
    (cust) =>
      cust.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (filterDate === "" || cust.createdAt?.split("T")[0] === filterDate)
  );

  return (
    <>
      <div className="p-2">
        <div className="d-flex justify-content-between">
          <h1 className="text-center text-lemon" style={{ fontSize: 28 }}>
            Material List
          </h1>
          <div className="d-flex justify-content-end mb-5">
            <button
              onClick={openAddModal}
              style={{
                backgroundColor: "#6fb104",
                color: "white",
                borderRadius: 6,
                fontWeight: "600",
                padding: "8px 16px",
                transition: "background-color 0.3s ease",
                border: "none",
              }}
            >
              Add Material
            </button>
          </div>
        </div>

        {/* Loader */}
        {loading && (
          <div className="d-flex justify-content-center my-5">
            <FaSpinner className="spin" style={{ fontSize: 50, color: "#6fb104" }} />
          </div>
        )}

        {/* Filter Inputs */}
        {!loading && (
          <div className="d-flex gap-3 mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="form-control rounded-pill  p-2"
              style={{ maxWidth: 600 }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <input
              type="date"
              className="form-control rounded-pill p-2"
              style={{ maxWidth: 300 }}
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
            />
          </div>
        )}

        {!loading && (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{ backgroundColor: "#6fb104", color: "white" }}>
                <tr>
                  <th
                    className="py-3 px-4"
                    style={{ fontWeight: 600, fontSize: 16 }}
                  >
                    Name
                  </th>
                  <th
                    className="py-3 px-4"
                    style={{ fontWeight: 600, fontSize: 16 }}
                  >
                    Creation Date
                  </th>
                  <th
                    className="py-3 px-4 text-center"
                    style={{ fontWeight: 600, fontSize: 16 }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredCustomers.map((cust) => (
                  <tr
                    key={cust._id}
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <td
                      className="align-middle py-3 px-4"
                      style={{ fontSize: 15, color: "#333" }}
                    >
                      {cust.name}
                    </td>
                    <td
                      className="align-middle py-3 px-4"
                      style={{ fontSize: 15, color: "#333" }}
                    >
                      {new Date(cust.createdAt).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </td>
                    <td className="align-middle py-3 px-4 text-center">
                      <button
                        className="me-2"
                        style={{
                          backgroundColor: "#6fb104",
                          color: "#fff",
                          borderRadius: 5,
                          fontWeight: 600,
                          padding: "6px 12px",
                          border: "none",
                        }}
                        onClick={() => openEditModal(cust)}
                      >
                        <FaEdit /> Edit
                      </button>
                      <button
                        style={{
                          backgroundColor: "#6fb104",
                          color: "white",
                          borderRadius: 5,
                          fontWeight: 600,
                          padding: "6px 12px",
                          border: "none",
                        }}
                        onClick={() => handleDelete(cust._id)}
                      >
                        <FaTrash /> Delete
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredCustomers.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      className="text-center py-4"
                      style={{ color: "#777" }}
                    >
                      No materials found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.45)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            padding: 20,
          }}
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-3 p-4 position-relative"
            style={{
              maxWidth: 500,
              width: "100%",
              boxShadow:
                "0 5px 15px rgba(90, 42, 130, 0.4), 0 15px 30px rgba(90, 42, 130, 0.2)",
              borderRadius: 18,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="btn position-absolute"
              style={{
                top: 18,
                right: 18,
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
              aria-label="Close modal"
            >
              <FaTimes size={22} color="#6fb104" />
            </button>

            <h3
              className="mb-4 text-center"
              style={{ color: "#6fb104", fontWeight: "700" }}
            >
              {isEditMode ? "Edit Material" : "Add New Material"}
            </h3>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: 600, color: "#6fb104" }}
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  placeholder="Enter name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ borderRadius: 5 }}
                />
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#6fb104",
                    color: "white",
                    padding: "10px 24px",
                    borderRadius: 6,
                    fontWeight: 600,
                    border: "none",
                  }}
                >
                  {isEditMode ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
